import { Group, Button, Select, NumberInput, Stack } from '@mantine/core';
import { DatePickerInput, TimePicker } from '@mantine/dates';
import { EditShiftFormProps } from '@company/types/worker-modal.type';

export default function EditShiftForm({
  formData,
  onFormDataChange,
  onSubmit,
  onCancel,
  isLoading,
  jobOptions,
}: EditShiftFormProps) {
  const handleFormDataChange = (updates: Partial<typeof formData>) => {
    onFormDataChange({ ...formData, ...updates });
  };

  return (
    <Stack gap="md">
      {/* Input Row */}
      <Group gap="lg" align="flex-end">
        <DatePickerInput
          label="DATE"
          value={formData.date}
          onChange={(date) =>
            handleFormDataChange({
              date: date ? new Date(date) : null,
            })
          }
          placeholder="Select date"
        />
        <Select
          label="POSITION"
          value={formData.positionId.toString()}
          onChange={(value) => {
            const selectedPosition = jobOptions?.jobTitles?.find(
              (title) => title.id.toString() === value
            );
            handleFormDataChange({
              positionId: selectedPosition?.id || 0,
              positionName: selectedPosition?.name || '',
            });
          }}
          data={
            jobOptions?.jobTitles?.map((title) => ({
              value: title.id.toString(),
              label: title.name,
            })) || []
          }
          placeholder="Select position"
          checkIconPosition="right"
          style={{ width: '250px' }}
        />
        <NumberInput
          label="WAGE"
          value={formData.wage}
          onChange={(value) =>
            handleFormDataChange({
              wage: Number(value) || 0,
            })
          }
          prefix="$"
          decimalScale={2}
          min={0}
          style={{ width: '80px' }}
        />
        <Select
          label="HOURLY/DAILY"
          value={formData.payRatePeriod}
          onChange={(value) =>
            handleFormDataChange({
              payRatePeriod: (value as 'hourly' | 'daily') || 'hourly',
            })
          }
          data={[
            { value: 'hourly', label: 'Hourly' },
            { value: 'daily', label: 'Daily' },
          ]}
          style={{ width: '100px' }}
        />
        <TimePicker
          label="START TIME"
          value={
            formData.startTime
              ? formData.startTime.toTimeString().slice(0, 5)
              : ''
          }
          onChange={(time) =>
            handleFormDataChange({
              startTime: time ? new Date(`2000-01-01T${time}`) : null,
            })
          }
          withDropdown
          withSeconds={false}
          format="12h"
          style={{ width: '100px' }}
        />
        <TimePicker
          label="END TIME"
          value={
            formData.endTime ? formData.endTime.toTimeString().slice(0, 5) : ''
          }
          onChange={(time) =>
            handleFormDataChange({
              endTime: time ? new Date(`2000-01-01T${time}`) : null,
            })
          }
          withDropdown
          withSeconds={false}
          format="12h"
          style={{ width: '100px' }}
        />
        <Select
          label="PAID BREAK"
          value={formData.paidBreak}
          onChange={(value) =>
            handleFormDataChange({
              paidBreak: (value as 'yes' | 'no') || 'yes',
            })
          }
          data={[
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' },
          ]}
          style={{ width: '100px' }}
        />
      </Group>

      {/* Button Row */}
      <Group justify="flex-end" gap="sm" mt="md">
        <Button variant="light" onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="yellow" onClick={onSubmit} loading={isLoading}>
          Update
        </Button>
      </Group>
    </Stack>
  );
}
